class EivykProductSpecifications extends HTMLElement {
  connectedCallback() {
    this.showVariant(this.dataset.initialVariantId);
    this.bindVariantChanges();
  }

  bindVariantChanges(attempt = 0) {
    const pubsub = window.FoxTheme?.pubsub;
    const eventName = pubsub?.PUB_SUB_EVENTS?.variantChange;

    if (pubsub?.subscribe && eventName) {
      this.unsubscribe = pubsub.subscribe(eventName, ({ data } = {}) => {
        if (data?.variant?.id) this.showVariant(data.variant.id);
      });
      return;
    }

    if (attempt < 20) {
      window.setTimeout(() => this.bindVariantChanges(attempt + 1), 100);
    }
  }

  showVariant(id) {
    if (!id) return;
    this.querySelectorAll('[data-eivyk-variant-specs]').forEach((panel) => {
      panel.hidden = panel.dataset.eivykVariantSpecs !== String(id);
    });
  }

  disconnectedCallback() {
    if (typeof this.unsubscribe === 'function') this.unsubscribe();
  }
}

if (!customElements.get('eivyk-product-specifications')) {
  customElements.define('eivyk-product-specifications', EivykProductSpecifications);
}
